"use strict";

exports.__esModule = true;
exports.TicketWatcherRuleForm = TicketWatcherRuleForm;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Form = require("../../Form");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
var _DeviceSelector = require("../../Device/DeviceSelector");
var _DeviceTagSelector = require("../../Device/DeviceTagSelector");
var _User = require("../../User");
var _TicketTypeSelector = require("../../TicketTypes/TicketTypeSelector");
var _System = require("../../../System");
var _DaysOfTheWeekSelector = require("../../Core/DaysOfTheWeekSelector");
var _ActionSelector = require("../../Core/ActionSelector");
var _constants = require("../constants");
var _UI = require("../../../Utils/UI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TicketWatcherRuleForm(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var deviceTags = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  var _React$useContext2 = _react["default"].useContext(_User.UserListContext),
    users = _React$useContext2.userList;

  // The server doesn't appear to support delete.
  // Remove this when it does.
  var enableDeleteButton = false;
  var validate = function validate(input) {
    var errors = {};
    if (input.users.length === 0 && input.emails.length === 0) {
      var error = translate("TicketWatcherRuleForm.validate.noWatchers", "Must select at least one user or email address.");
      errors.users = error;
      errors.emails = error;
    }
    return errors;
  };
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, _extends({
    "data-testid": "TicketWatcherRuleForm",
    validate: validate
  }, props), function (_ref) {
    var handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      pristine = _ref.pristine,
      submitting = _ref.submitting;
    return /*#__PURE__*/_react["default"].createElement("form", {
      style: {
        overflow: "auto"
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.Prompt, {
      when: !pristine && !submitting,
      message: translate("TicketWatcherRuleForm.prompt.message", "Are you sure you want to leave this page without saving your changes?")
    }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      type: "submit",
      disabled: pristine || invalid,
      "data-testid": "TicketWatcher.SaveButtonTestId",
      text: translate("TicketWatcherRuleForm.saveButton.text", "Save")
    }), enableDeleteButton && props.onDelete && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
      icon: _icons.IconNames.DELETE,
      intent: _core.Intent.DANGER,
      minimal: true,
      onClick: props.onDelete,
      confirm: translate("TicketWatcherRuleForm.deleteButton.confirm", "Are you sure you want to delete this watcher rule?"),
      "data-testid": "TicketWatcher.DeleteButtonTestId",
      text: translate("TicketWatcherRuleForm.deleteButton.text", "Delete")
    }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      minimal: true,
      end: true,
      icon: _icons.IconNames.CROSS,
      to: (0, _System.getScreenLocation)("TicketWatcherRuleList"),
      text: translate("TicketWatcherRuleForm.cancelButton.text", "Cancel")
    }))), /*#__PURE__*/_react["default"].createElement(_Core.Content, null, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      validateOnPopup: true,
      name: "name",
      validate: function validate(name) {
        if (!name) {
          return "Name is required.";
        }
      },
      label: translate("TicketWatcherRuleForm.name.label", "Name"),
      helperText: translate("TicketWatcherRuleForm.name.helperText", "The name for this watcher rule."),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
        "data-testid": "TicketWatcher.NameInputTestId"
      }));
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "enabled",
      type: "checkbox",
      label: translate("TicketWatcherRuleForm.enable.label", "Rule Status")
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
        label: translate("TicketWatcherRuleForm.enable.enabled.label", "Enabled"),
        "data-testid": "TicketWatcher.IsEnabledStatusTestId"
      }, input, {
        onChange: function onChange(event) {
          input.onChange(event);
          if (!event.target.checked) (0, _UI.showWarningToaster)(translate("TicketWatcherRuleForm.toast.disableWatcherRule", "Note: Disabling a watcher rule will cause emails to not be sent for all participants of the watcher rule"));
        }
      }));
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "types",
      validate: function validate(name) {
        if (name === void 0) {
          name = [];
        }
        if (name.length < 1) {
          return translate("TicketWatcherRuleForm.types.requiredLabelText", "At least 1 ticket type is required.");
        }
      },
      validateOnPopup: true,
      label: translate("TicketWatcherRuleForm.types.label", "Ticket Types"),
      helperText: translate("TicketWatcherRuleForm.types.helperText", "The ticket types for this watcher rule."),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeSelector.TicketTypeSelector, {
        multiple: true,
        selected: input.value || [],
        dataTestId: "TicketWatcher.TicketTypeSelectorTestId",
        tagInputProps: {
          inputProps: {
            id: input.id
          },
          intent: input.intent
        },
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (item) {
            return typeof item === "string" ? item : item.id;
          }));
        }
      });
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "actions",
      label: translate("TicketWatcherRuleForm.action.label", "Actions"),
      helperText: translate("TicketWatcherRuleForm.action.helperText", "The actions for this watcher rule.")
    }, function (_ref5) {
      var input = _ref5.input;
      return /*#__PURE__*/_react["default"].createElement(_ActionSelector.ActionSelector, {
        multiple: true,
        selected: input.value || [],
        items: _constants.ACTION_TYPES,
        dataTestId: "TicketWatcher.ActionSelectorTestId",
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (item) {
            return typeof item === "string" ? item : item.id;
          }));
        }
      });
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "devices",
      label: translate("TicketWatcherRuleForm.devices.label", "Devices"),
      helperText: translate("TicketWatcherRuleForm.devices.helperText", "The devices for this watcher rule.")
    }, function (_ref6) {
      var input = _ref6.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, {
        multiple: true,
        selected: input.value || [],
        items: devices,
        dataTestId: "TicketWatcher.DeviceSelectorTestId",
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (item) {
            return typeof item === "string" ? item : item.uuid;
          }));
        }
      });
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "deviceTags",
      label: translate("TicketWatcherRuleForm.deviceTags.label", "Groups"),
      helperText: translate("TicketWatcherRuleForm.deviceTags.helperText", "The device groups for this watcher rule.")
    }, function (_ref7) {
      var input = _ref7.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
        multiple: true,
        selected: input.value || [],
        items: deviceTags,
        dataTestId: "TicketWatcher.DeviceTagSelectorTestId",
        onSelect: function onSelect(selected) {
          return input.onChange(selected);
        }
      });
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      validateOnPopup: true,
      name: "users",
      label: translate("TicketWatcherRuleForm.users.label", "Users"),
      helperText: translate("TicketWatcherRuleForm.users.helperText", "The users for this watcher rule.")
    }, function (_ref8) {
      var input = _ref8.input;
      return /*#__PURE__*/_react["default"].createElement(_User.UserSelector, {
        multiple: true,
        getKey: function getKey(item) {
          return item.id;
        },
        selected: input.value || [],
        items: users,
        tagInputProps: {
          inputProps: {
            id: input.id
          },
          intent: input.intent
        },
        usePortal: true,
        popoverProps: {
          usePortal: true,
          minimal: true,
          popoverClassName: "vi-select-popover"
        },
        dataTestId: "TicketWatcher.UserSelectorTestId",
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (item) {
            return typeof item === "string" ? item : item.id;
          }));
        }
      });
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      validateOnPopup: true,
      name: "emails",
      label: translate("TicketWatcherRuleForm.emails.label", "Email Addresses"),
      helperText: translate("TicketWatcherRuleForm.emails.helperText", "The emails for this watcher rule.")
    }, function (_ref9) {
      var input = _ref9.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TagInput, {
        addOnBlur: true,
        large: true,
        separator: " ",
        onChange: input.onChange,
        intent: input.intent,
        values: input.value || [],
        inputProps: {
          "data-testid": "TicketWatcher.EmailInputTestId"
        }
      });
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      validateOnPopup: true,
      name: "from",
      validate: function validate(value) {
        if (!value) {
          return "Start time is required.";
        }
      },
      label: translate("TicketWatcherRuleForm.from.label", "From"),
      helperText: translate("TicketWatcherRuleForm.from.helperText", "The start time for this watcher rule."),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
    }, function (_ref0) {
      var input = _ref0.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        fill: true,
        type: "time"
      }, input, {
        "data-testid": "TicketWatcher.FromInputTestId"
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      validateOnPopup: true,
      name: "to",
      validate: function validate(value) {
        if (!value) {
          return "End time is required.";
        }
      },
      label: translate("TicketWatcherRuleForm.to.label", "To"),
      helperText: translate("TicketWatcherRuleForm.to.helperText", "The end time for this watcher rule."),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
    }, function (_ref1) {
      var input = _ref1.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        fill: true,
        type: "time"
      }, input, {
        "data-testid": "TicketWatcher.ToInputTestId"
      }));
    }))), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "daysOfTheWeek",
      label: translate("TicketWatcherRuleForm.daysOfTheWeek.label", "Days of the week"),
      helperText: translate("TicketWatcherRuleForm.daysOfTheWeek.helperText", "Select days of the week in which tickets will work")
    }, function (_ref10) {
      var input = _ref10.input;
      return /*#__PURE__*/_react["default"].createElement(_DaysOfTheWeekSelector.DaysOfTheWeekSelector, {
        disabled: false,
        maxWidth: 700,
        margin: "left",
        inline: true,
        selectedDays: input.value || new Array(),
        onSelect: function onSelect(selected) {
          return input.onChange(selected);
        }
      });
    })));
  });
}